export let messageExtensionAppInstalledTitle = "jn5Jde";
export let messageExtensionAppInstalledSubTitle = "BfmExc";
export let messageExtensionAppInstalledCloseButtonLabel = "NE3WXd";
export let appHostDiagnosticDataDescription = "cWK3jc";
export default {messageExtensionAppInstalledTitle,messageExtensionAppInstalledSubTitle,messageExtensionAppInstalledCloseButtonLabel,appHostDiagnosticDataDescription};